import { Inject, Injectable } from '@angular/core';
import { ButtonType } from '@challenger6/vm-pattern-library/button/button.interface';
import { FaultArticle } from '../modules/graphql/generated/graphql-types';
import { SessionService } from '../services/session.service';
import { FaultArticleService } from './fault-article.service';
import { ManageTransactionDataService } from './manage-transaction-data.service';
import { LIB_CONFIG } from '../lib-config';
import { LibConfig } from '../models/lib-config.model';
import { CareAnalyticsService } from './care-analytics.service';
import { CallType } from './care-analytics.enum';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class PriorityCallService {
  CallUsLabel = 'Call us';
  PriorityCallLabel = '';
  PriorityCallModal = '';
  PriorityCalTelNos = [];

  constructor(
    private manageTransactionDataService: ManageTransactionDataService,
    private faultArticleService: FaultArticleService,
    private sessionService: SessionService,
    private careAnalyticsService: CareAnalyticsService,
    @Inject(LIB_CONFIG) private config: LibConfig
  ) {
    this.getPriorityCallArticle();
  }

  protected getPriorityCallArticle(): void {
    const appName = this.config.appName;
    const strapiUID = appName !== 'tv-fault' ? 'angular-care-priority-call' : 'angular-care-priority-call-tv';

    if (!this.PriorityCallLabel && !this.PriorityCallModal) {
      this.faultArticleService.getArticle(strapiUID).subscribe((faultArticle: FaultArticle) => {
        this.PriorityCallLabel = (faultArticle as any)?.elements[0]?.genericComponent[0]?.ctas[0]?.label;
        this.PriorityCallModal = (faultArticle as any)?.elements[0]?.genericComponent[1]?.copy;
        this.PriorityCalTelNos = (faultArticle as any)?.elements[0]?.genericComponent[1]?.listOfContent;
      });
    }
  }

  public setTileContent(tiles: any, ivrPriority = false, ivrPriorityIdentified = true): any {
    if (tiles) {
      tiles.forEach((tile) => {
        if (ivrPriority && tile.title === this.CallUsLabel) {
          tile.title = this.PriorityCallLabel;
          tile.modalTitle = this.PriorityCallLabel;
          tile.modalCopy = this.setTelephoneNumber(ivrPriorityIdentified);
        }
      });
      return tiles;
    }
    return tiles;
  }

  public setTelephoneNumber(ivrPriorityIdentified: boolean): string {
    const ivrIdentified = ivrPriorityIdentified ? 'identified' : 'unidentified';
    const priorityCallTelNo = this.PriorityCalTelNos.find((item) => item.text === ivrIdentified);

    return this.PriorityCallModal.replace('<telephone_number>', priorityCallTelNo.content);
  }

  public setButtonLabel(buttonLabel: string, buttonType: ButtonType, ivrPriority = false): string {
    if (ivrPriority && buttonLabel === this.CallUsLabel && buttonType === ButtonType.MODAL) {
      return this.PriorityCallLabel;
    }
    return buttonLabel;
  }

  public setModalContent(
    modalLabel: string,
    modalCopy: string,
    ivrPriority = false,
    ivrPriorityIdentified = true
  ): string {
    if (ivrPriority && modalLabel === this.CallUsLabel) {
      return this.setTelephoneNumber(ivrPriorityIdentified);
    }
    return modalCopy;
  }

  public createPriorityCallMTD(e: any, isPriority: boolean = false): void {
    if (e?.srcElement?.innerText === this.PriorityCallLabel || e?.title === this.PriorityCallLabel || isPriority) {
      this.careAnalyticsService.trackCallModalViewEvent(CallType.PRIORITY);
      this.sessionService.getSessionData().subscribe((ses) => {
        const actionCode = ses?.angularPublicSession?.diagnosticsActionCode;
        const adviceCode = window.document.location.href?.split('/')?.slice(-2, -1)?.pop()?.toUpperCase();
        const nextAction = NEXT_ACTION_DESCRIPTION[adviceCode] || 'Advised to call';
        const uuid = uuidv4();
        this.manageTransactionDataService.priorityCall(
          uuid,
          `FLT:${actionCode}`,
          nextAction,
          ses?.angularPublicSession?.tid
        );
        this.careAnalyticsService.trackPriorityCallEvent(uuid);
      });
    } else {
      this.careAnalyticsService.trackCallModalViewEvent(CallType.GENERAL);
    }
  }
}
/* eslint-disable */
export const NEXT_ACTION_DESCRIPTION = {
  'HUB-POSITION': 'Hub positioning advice shown',
  'BLACK-SPOTS': 'App for WiFi blackspots suggested',
  'WHICH-DEVICE': 'Single device connection advice shown',
  'WIRED-CONNECTION': 'Try a wired connection suggested',
  'RESET-HUB': 'Hub reset advice shown',
};
/* eslint-enable */
